module.exports = __webpack_public_path__ + "static/media/gmn-screen-dept.f19f0790.png";